import { Helmet } from "react-helmet";

const HelmetServer = ({ children }: any) => (!__CLIENT__ ? <Helmet>{children}</Helmet> : <></>);

export default HelmetServer;
